<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row" :gutter="24">
        <a-col :span="6">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="经销商"
          >
            <a-input-search
              @search="selectdealer"
              :read-only="true"
              :disabled="this.params.isShow || this.params.id > 0"
              enterButton="选择"
              placeholder="请选择经销商"
              v-decorator="[
                'dealerName',
                {
                  rules: [{ required: true, message: '请选择经销商' }],
                  initialValue: data.dealerName,
                },
              ]"
            >
            </a-input-search>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="销售组织"
          >
            <a-select
              placeholder="请选择销售组织"
              @change="orgChange"
              :disabled="disabledOrg || this.params.id > 0"
              :options="this.organizationOptions"
              v-decorator="[
                'organizationId',
                {
                  initialValue: data.organizationId,
                  rules: [{ required: true, message: '请选择销售组织' }],
                },
              ]"
            ></a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="部门"
          >
            <a-select
              placeholder="请选择部门"
              :options="this.departmentOptions"
              :disabled="this.params.isShow"
              v-decorator="[
                'departmentId',
                {
                  initialValue: data.departmentId,
                  rules: [{ required: false, message: '请选择部门' }],
                },
              ]"
            ></a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="销售员"
          >
            <a-input-search
              :read-only="true"
              :disabled="this.params.isShow"
              placeholder="请选择销售员"
              @search="onEmployeeSearch"
              v-decorator="[
                'saleEmployeeName',
                {
                  rules: [{ required: true, message: '请选择销售员' }],
                  initialValue: data.saleEmployeeName,
                },
              ]"
            ></a-input-search>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="6">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="联系人"
          >
            <a-input
              :read-only="true"
              placeholder="请输入联系人"
              v-decorator="[
                'contact',
                {
                  rules: [{ required: false, message: '请输入联系人' }],
                  initialValue: data.contact,
                },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="联系电话"
          >
            <a-input
              :read-only="true"
              placeholder="请输入联系电话"
              v-decorator="[
                'telephone',
                {
                  rules: [{ required: false, message: '请输入联系电话' }],
                  initialValue: data.telephone,
                },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <!-- <a-col :span="6">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收货地址">
            <a-cascader :disabled="this.params.isShow" :options="addressOptions" expandTrigger="hover" @change="changeAddressdata" placeholder="请选择地址" v-decorator="[
          'defaultValue',
          {initialValue:defaultValue,rules: [{ required: true, message: '请选择地址' }]}]" />
          </a-form-item>
        </a-col> -->
        <a-col :span="6">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="收货地址"
          >
            <a-input-search
              :read-only="true"
              placeholder="请选择收货地址"
              @search="onAddressSearch"
              v-decorator="[
                'detailAddress',
                {
                  initialValue: data.detailAddress,
                  rules: [{ required: true, message: '请选择收货地址' }],
                },
              ]"
            ></a-input-search>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="发货方式"
          >
            <a-select
              @change="methodChange"
              :disabled="this.params.isShow"
              placeholder="请选择发货方式"
              v-decorator="[
                'deliveryMethod',
                {
                  initialValue: data.deliveryMethod,
                  rules: [{ required: true, message: '请选择发货方式' }],
                },
              ]"
            >
              <a-select-option value="0">零担</a-select-option>
              <a-select-option value="1">整车</a-select-option>
              <a-select-option value="2">自提</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24" v-if="this.isBreakBulk">
        <a-col :span="6">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="货运部"
          >
            <a-input-search
              :read-only="true"
              :disabled="this.params.isShow"
              placeholder="请选择货运部"
              @search="onFreightSearch"
              v-decorator="['freightName', { initialValue: data.freightName }]"
            ></a-input-search>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="货运部电话"
          >
            <a-input
              :read-only="true"
              placeholder="请输入货运部电话"
              v-decorator="[
                'freightTelephone',
                { initialValue: data.freightTelephone },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <!-- <a-col :span="6">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货仓">
            <a-select :disabled="this.params.isShow" placeholder="请选择发货仓" v-decorator="[
          'warehouse',
          {initialValue:data.warehouse,rules: [{ required: true, message: '请选择发货仓' }]}]">
              <a-select-option value="0">分仓</a-select-option>
              <a-select-option value="1">总仓</a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->

        <a-col :span="6" v-if="!this.params.isShow">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="信用额度"
          >
            <label>{{ availableBalance }}</label>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="订单金额"
          >
            <label>{{ totalAmount }}</label>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24" v-if="this.params.isShow">
        <a-col :span="17">
          <a-form-item
            :labelCol="{
              xs: { span: 24 },
              sm: { span: 2 },
            }"
            :wrapperCol="{
              xs: { span: 24 },
              sm: { span: 22 },
            }"
            label="前台备注"
          >
            <a-input
              :read-only="this.params.isShow"
              placeholder=""
              v-decorator="['frontNotes', { initialValue: data.frontNotes }]"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="17">
          <a-form-item
            :labelCol="{
              xs: { span: 24 },
              sm: { span: 2 },
            }"
            :wrapperCol="{
              xs: { span: 24 },
              sm: { span: 22 },
            }"
            label="后台备注"
          >
            <a-input
              :read-only="this.params.isShow"
              :placeholder="this.params.isShow ? '' : '请输入备注'"
              v-decorator="['backNotes', { initialValue: data.backNotes }]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="4" v-if="!this.params.isShow && !(this.params.id > 0)">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="">
            <a-button type="primary" @click="selectProduct" :disabled="loading"
              >选择产品</a-button
            >
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24" v-if="this.params.isShow">
        <a-col :span="17">
          <a-form-item
            :labelCol="{
              xs: { span: 24 },
              sm: { span: 2 },
            }"
            :wrapperCol="{
              xs: { span: 24 },
              sm: { span: 22 },
            }"
            label="审核说明"
          >
            <a-input
              :read-only="this.params.isShow"
              placeholder=""
              v-decorator="['auditNotes', { initialValue: data.auditNotes }]"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="24">
          <label v-if="disabledOrg && !this.params.isShow" style="color: red"
            >说明：若需修改行项目信息，请先在操作列点击“编辑”，修改完后请记得点击“保存”</label
          >
          <a-table
            :columns="productColumns"
            :dataSource="productList"
            bordered
            :pagination="false"
            :scroll="{ x: this.itemTableWidth }"
            :rowKey="
              (record) => {
                return record.id;
              }
            "
          >
            <template slot="price" slot-scope="text, record, index">
              <div>
                <a-input
                  v-if="
                    record.editable &&
                    record.isCustom == true &&
                    record.isBom == false
                  "
                  style="margin: -5px 0"
                  :value="text"
                  type="number"
                  @change="
                    (e) => productChange(e.target.value, record.id, 'price')
                  "
                />
                <template v-else>{{ text }}</template>
              </div>
            </template>
            <template slot="quantity" slot-scope="text, record, index">
              <div>
                <a-input
                  v-if="record.editable && record.parentProductId == 0"
                  style="margin: -5px 0"
                  :value="text"
                  type="number"
                  @change="
                    (e) => productChange(e.target.value, record.id, 'quantity')
                  "
                />
                <template v-else>{{ text }}</template>
              </div>
            </template>
            <template slot="notes" slot-scope="text, record, index">
              <div>
                <a-input
                  v-if="
                    record.editable &&
                    (record.parentProductId > 0 || !record.isBom)
                  "
                  style="margin: -5px 0"
                  :value="text"
                  type="text"
                  @change="
                    (e) => productChange(e.target.value, record.id, 'notes')
                  "
                />
                <template v-else>{{ text }}</template>
              </div>
            </template>
            <template slot="lotNumber" slot-scope="text, record, index">
              <div>
                <a-input
                  v-if="
                    record.editable &&
                    (record.parentProductId > 0 || !record.isBom)
                  "
                  style="margin: -5px 0"
                  :value="text"
                  type="text"
                  @change="
                    (e) => productChange(e.target.value, record.id, 'lotNumber')
                  "
                />
                <template v-else>{{ text }}</template>
              </div>
            </template>
            <template
              slot="dealerExpectedDeliveryDate"
              slot-scope="text, record, index"
            >
              <div>
                <a-date-picker
                  v-if="record.editable && record.parentProductId == 0"
                  format="YYYY-MM-DD"
                  :disabledDate="
                    (current) =>
                      disabledDate(current, record.expectedDeliveryDate)
                  "
                  @change="
                    (date, dateString) =>
                      productChange(
                        date,
                        record.id,
                        'dealerExpectedDeliveryDate'
                      )
                  "
                />
                <template v-else>{{
                  record.parentProductId == 0
                    ? formatDate(
                        record.dealerExpectedDeliveryDate,
                        "YYYY-MM-DD"
                      )
                    : ""
                }}</template>
              </div>
            </template>
            <template slot="activity" slot-scope="text, record, index">
              <div>
                <template>{{ record.activityName }}</template>
              </div>
            </template>
            <template slot="operation" slot-scope="text, record, index">
              <div class="editable-row-operations">
                <span v-if="record.editable">
                  <a @click="() => save(record.id, record.parentProductId)"
                    >保存</a
                  >
                </span>
                <span v-else>
                  <a @click="() => edit(record.id, record.parentProductId)"
                    >编辑</a
                  >
                  <a-divider
                    type="vertical"
                    v-if="record.parentProductId == 0"
                  />
                  <a
                    @click="() => remove(record.productId)"
                    v-if="record.parentProductId == 0"
                    >删除</a
                  >
                </span>
              </div>
            </template>

            <template slot="isProcess" slot-scope="text, record, index">
              <span>
                <a-checkbox
                  :defaultChecked="
                    record.isProcess != null ? record.isProcess : false
                  "
                  @change="(e) => onChange(e.target, record.id, 'isProcess')"
                  >是否加工</a-checkbox
                >
              </span>
            </template>
          </a-table>
          <!--           <a-table :columns="productColumns" :dataSource="productList" bordered :pagination="false" :scroll="{x:this.itemTableWidth}" :rowKey="record=> {return record.productId +'-'+record.parentProductId;}">
            <template slot="price" slot-scope="text,record,index">
              <div>
                <a-input v-if="record.editable && record.isCustom==true && record.isBom==false" style="margin: -5px 0" :value="text" type="number" @change="e => productChange(e.target.value, record.productId, 'price')" />
                <template v-else>{{text}}</template>
              </div>
            </template>
            <template slot="quantity" slot-scope="text,record,index">
              <div>
                <a-input v-if="record.editable && record.parentProductId==0" style="margin: -5px 0" :value="text" type="number" @change="e => productChange(e.target.value, record.productId, 'quantity')" />
                <template v-else>{{text}}</template>
              </div>
            </template>
            <template slot="notes" slot-scope="text,record,index">
              <div>
                <a-input v-if="record.editable && (record.parentProductId>0 || !record.isBom)" style="margin: -5px 0" :value="text" type="text" @change="e => productChange(e.target.value, record.productId, 'notes')" />
                <template v-else>{{text}}</template>
              </div>
            </template>
            <template slot="lotNumber" slot-scope="text,record,index">
              <div>
                <a-input v-if="record.editable && (record.parentProductId>0 || !record.isBom)" style="margin: -5px 0" :value="text" type="text" @change="e => productChange(e.target.value, record.productId, 'lotNumber')" />
                <template v-else>{{text}}</template>
              </div>
            </template>
            <template slot="dealerExpectedDeliveryDate" slot-scope="text,record,index">
              <div>
                <a-date-picker v-if="record.editable && record.parentProductId==0" format="YYYY-MM-DD" :disabledDate="(current)=> disabledDate(current,record.expectedDeliveryDate)" @change="(date, dateString)=>productChange(date, record.productId, 'dealerExpectedDeliveryDate')" />
                <template v-else>{{record.parentProductId==0? formatDate(record.dealerExpectedDeliveryDate, "YYYY-MM-DD"):""}}</template>
              </div>
            </template>
            <template slot="activity" slot-scope="text,record,index">
              <div v-if="record.id==0 && record.parentProductId==0">
                <a-select v-if="record.editable" placeholder="请选择促销活动" :v-model="record.activityId" :options="record.activityOptions" style="width: 180px;" @change="v=>activityChange(v, record.productId)"></a-select>
                <template v-else>{{record.activityDes }}</template>
              </div>
              <div v-else>
                <template>{{record.activityName }}</template>
              </div>
            </template>
            <template slot="operation" slot-scope="text,record,index">
              <div class='editable-row-operations'>
                <span v-if="record.editable">
                  <a @click="() => save(record.productId,record.parentProductId)">保存</a>
                </span>
                <span v-else>
                  <a @click="() => edit(record.productId,record.parentProductId)">编辑</a>
                  <a-divider type="vertical" v-if="record.parentProductId==0" />
                  <a @click="()=>remove(record.productId)" v-if="record.parentProductId==0">删除</a>
                </span>
              </div>
            </template>
            <template slot="isProcess" slot-scope="text,record,index">
              <span v-if="!record.isBom">
                <a-checkbox :disabled="params.isShow" :defaultChecked="record.isProcess!=null?record.isProcess:false" @change="e => onChange(e.target, record.productId, 'isProcess')">是否加工</a-checkbox>
              </span>
            </template>
          </a-table> -->
        </a-col>
      </a-row>
      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label>
          <a-button type="primary" @click="submit" :loading="loading"
            >确认</a-button
          >
          <a-button style="margin-left: 10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
    <hp-manager-modal
      width="1300px"
      :title="'选择产品'"
      v-model="selectVisible"
    >
      <hp-manager-page-product-select
        slot="slot"
        @getSelectedProduct="getProductInfo"
        @cancel="selectVisible = false"
        :params="selectProductParams"
      ></hp-manager-page-product-select>
    </hp-manager-modal>

    <hp-manager-modal
      width="1300px"
      :title="'选择经销商'"
      v-model="dealerVisible"
    >
      <hp-manager-page-dealer-select
        slot="slot"
        @getSelectedDealer="getSelectedDealer"
        @cancel="dealerVisible = false"
      ></hp-manager-page-dealer-select>
    </hp-manager-modal>
    <hp-manager-modal
      width="1000px"
      :title="'选择销售员'"
      v-model="selectEmployeeVisible"
    >
      <hp-manager-page-employee-select
        slot="slot"
        @getSelectedEmployee="getSelectedEmployee"
        @cancel="selectEmployeeVisible = false"
        :paramsX="selectEmployeeParams"
      ></hp-manager-page-employee-select>
    </hp-manager-modal>
    <hp-manager-modal
      width="1000px"
      :title="'选择地址'"
      v-model="selectAddressVisible"
    >
      <hp-manager-page-address-select
        slot="slot"
        @getSelectedDealerAddress="getSelectedDealerAddress"
        @cancel="selectAddressVisible = false"
        :paramsX="selectAddressParams"
      ></hp-manager-page-address-select>
    </hp-manager-modal>
    <hp-manager-modal
      width="1000px"
      :title="'选择货运部'"
      v-model="selectFreightVisible"
    >
      <hp-manager-page-freight-select
        slot="slot"
        @getSelectedDealerFreight="getSelectedDealerFreight"
        @cancel="selectFreightVisible = false"
        :paramsX="selectFreightParams"
      ></hp-manager-page-freight-select>
    </hp-manager-modal>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
import { constants } from "zlib";
import { setTimeout } from "timers";
import hpManagerPageProductSelect from "./../../Goods/Product/SelectProduct";
import hpManagerPageDealerSelect from "./../../Basic/Dealer/SelectList";
import hpManagerPageEmployeeSelect from "./../../Basic/Employee/SelectList";
import hpManagerPageAddressSelect from "./../../Basic/Dealer/SelectDealerAddress";
import hpManagerPageFreightSelect from "./../../Basic/Dealer/SelectDealerFreight";
const defaultData = {
  id: 0,
  dealerId: null,
  dealerName: "",
  dealerPhone: "",
  activityId: undefined,
  activityName: "",
  backNotes: "",
  salesId: "",
  salesName: "",
  provinceId: "",
  cityId: "",
  districtId: "",
  detailAddress: "",
  useCouponId: undefined,
  couponAmount: "",
  items: [],
};

export default {
  name: "hp-manager-page-ordermaster-add",
  components: {
    hpManagerPageProductSelect,
    hpManagerPageDealerSelect,
    hpManagerPageEmployeeSelect,
    hpManagerPageAddressSelect,
    hpManagerPageFreightSelect,
  },
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object,
  },

  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
      productColumns: [
        {
          title: "操作",
          dataIndex: "operation",
          width: 120,
          scopedSlots: { customRender: "operation" },
          fixed: "left",
        },
        {
          title: "产品名称",
          dataIndex: "productName",
          width: 300,
        },
        {
          title: "产品编码",
          dataIndex: "productCode",
          width: 100,
        },
        {
          title: "规格",
          dataIndex: "specDes",
          width: 160,
        },
        {
          title: "定制",
          dataIndex: "isCustom",
          width: 70,
          customRender: (text, row, index) => {
            return row.isCustom ? "是" : "否";
          },
        },
        {
          title: "是否加工",
          dataIndex: "isProcess",
          scopedSlots: { customRender: "isProcess" },
          width: 200,
        },
        {
          title: "是否欠货",
          dataIndex: "isInsufficient",
          width: 100,
          customRender: (text, row, index) => {
            return row.parentProductId > 0
              ? ""
              : row.isInsufficient
              ? "欠货"
              : "有货";
          },
        },
        {
          title: "加工工艺",
          dataIndex: "notes",
          scopedSlots: { customRender: "notes" },
          width: 200,
        },
        {
          title: "批号",
          dataIndex: "lotNumber",
          scopedSlots: { customRender: "lotNumber" },
          width: 160,
        },
        {
          title: "套件",
          dataIndex: "isBom",
          width: 70,
          customRender: (text, row, index) => {
            return row.isBom ? "是" : "否";
          },
        },
        {
          title: "数量",
          dataIndex: "quantity",
          width: 100,
          scopedSlots: { customRender: "quantity" },
        },
        {
          title: "价格",
          dataIndex: "price",
          width: 100,
          scopedSlots: { customRender: "price" },
        },
        {
          title: "预计交期",
          dataIndex: "expectedDeliveryDate",
          width: 100,
          customRender: (text, row, index) => {
            return this.formatDate(row.expectedDeliveryDate, "YYYY-MM-DD");
          },
        },
        {
          title: "要货日期",
          dataIndex: "dealerExpectedDeliveryDate",
          width: 140,
          scopedSlots: { customRender: "dealerExpectedDeliveryDate" },
        },
        {
          title: "活动",
          dataIndex: "activityId",
          width: 200,
          scopedSlots: { customRender: "activity" },
        },
        {
          title: "活动价",
          dataIndex: "activityPrice",
          width: 100,
        },
      ],
      addressOptions: config.addressJson,
      defaultValue: [],
      searchOption: [],
      fileList: [],
      dealerList: [],
      activityOptions: [],
      salesUserOption: [],
      couponOptions: [],
      departmentOptions: [],
      organizationOptions: [],
      selectVisible: false,
      productList: [],
      isInsufficientList: [],
      productIds: [],
      cacheData: [],
      selectEmployeeParams: null,
      selectProductParams: null,
      selectAddressParams: null,
      selectFreightParams: null,
      modalWidth: "1000px",
      dealerVisible: false,
      selectEmployeeVisible: false,
      selectAddressVisible: false,
      selectFreightVisible: false,
      dealerId: null,
      availableBalance: null,
      saleEmployeeId: null,
      freightDepartmentId: null,
      isHead: false,
      isBreakBulk: false,
      headOrgId: null,
      checkable: false,
      itemTableWidth: 0,
    };
  },
  computed: {
    totalAmount: function () {
      let a = 0;
      if (this.productList) {
        this.productList.forEach((q) => {
          if (q.parentProductId == 0) {
            a = a + q.quantity * q.price;
          }
        });
      }
      return Number(a).toFixed(2);
    },
    disabledOrg: function () {
      return this.productList && this.productList.length > 0;
    },
  },
  async mounted() {
    await this.getHeadOrg();
    if (this.params.id) {
      await this.getdetailOrder();
    } else {
      this.data = exzends(defaultData);
    }
    if (this.params.isShow) {
      this.productColumns = this.productColumns.filter(
        (a) => a.dataIndex != "operation"
      );
    }
    this.productColumns.forEach((x) => {
      this.itemTableWidth += x.width;
    });
    this.checkable = this.params.isShow;
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },
    disabledDate(current, expectedDeliveryDate) {
      return expectedDeliveryDate == null
        ? current && current < moment().endOf("day")
        : current && current < expectedDeliveryDate;
    },
    async getOrganizationOptions(dealerId) {
      let orgList = await api.GetOrganizationSelectByDealerId({
        dealerId: dealerId,
      });
      this.organizationOptions = [];
      if (orgList) {
        orgList.forEach((a) => {
          this.organizationOptions.push({
            label: a.text,
            value: a.value,
          });
        });
        let orgId = this.form.getFieldValue("organizationId");
        if (!(orgId > 0)) {
          this.form.setFields({
            organizationId: { value: orgList[0].value, errors: null },
          });
          this.orgChange(orgList[0].value);
        }
      }
    },
    async orgChange(value) {
      this.departmentOptions = [];
      this.getAvailableBalanceByDealerId(this.dealerId, value);
      this.GetSaleEmployee(this.dealerId, value);
      this.isHead = value == this.headOrgId;
      console.log(this.isHead);
      await this.getDepartmentOptions(value);

      this.form.resetFields(["departmentId"]);
    },
    async getHeadOrg() {
      var result = await api.GetHeadOrganization();
      if (result) {
        this.headOrgId = result.id;
      }
    },
    methodChange(value) {
      if (value == 0) {
        this.isBreakBulk = true;
        if (
          this.dealerId > 0 &&
          (this.freightDepartmentId == null || this.freightDepartmentId == 0)
        ) {
          this.getDealerFreightOptions(this.dealerId);
        }
      } else {
        this.freightDepartmentId = null;
        this.isBreakBulk = false;
      }
    },
    async getDepartmentOptions(orgId) {
      let departmentList = await api.GetDepartmentSelect({
        orgId: orgId,
        dealerId: this.dealerId,
      });
      if (departmentList) {
        departmentList.forEach((a) => {
          this.departmentOptions.push({
            label: a.text,
            value: a.value,
          });
        });
      }
      let x = departmentList.filter((x) => x.selected == true)[0];
      if (x) {
        this.form.setFields({
          departmentId: { value: x.value, errors: null },
        });
      }
    },
    edit(key, parentProductId) {
      const newData = [...this.productList];
      const target = newData.filter(
        (item) =>
          //key === item.productId && item.parentProductId === parentProductId
          key === item.id
      )[0];
      if (target) {
        target.editable = true;
        this.productList = newData;
      }
    },
    save(key, parentProductId) {
      const newData = [...this.productList];
      const target = newData.filter(
        (item) =>
          //key === item.productId && item.parentProductId === parentProductId
          key === item.id
      )[0];
      if (target) {
        if ((target.price || 0) < 0) {
          this.$message.warn("价格不正确，请检查");
          return;
        }
        delete target.editable;
        this.productList = newData;
        this.cacheData = newData.map((item) => ({ ...item }));
      }
    },
    onChange(target, key, column) {
      const newData = [...this.productList];
      //const product = newData.filter((item) => key === item.productId)[0];
      const product = newData.filter((item) => key === item.id)[0];
      if (product) {
        product[column] = target.checked;
        this.productList = newData;
      }
    },

    productChange(value, key, column) {
      const newData = [...this.productList];
      //const target = newData.filter((item) => key === item.productId)[0];
      const target = newData.filter((item) => key === item.id)[0];
      if (target) {
        target[column] = value;
        this.productList = newData;
      }
    },
    remove(key) {
      let newData = [...this.productList];
      newData = newData.filter((item) => key != item.productId);
      newData = newData.filter((item) => key != item.parentProductId);
      // newData.filter(function(item, index) {
      //   newData.splice(index, 1);
      // });
      this.productList = newData;
    },
    activityChange(value, key) {
      const newData = [...this.productList];
      const target = newData.filter((item) => key === item.productId)[0];
      if (target) {
        let options = target["activityOptions"];
        let opt = options.filter((x) => x.value == value)[0];
        if (opt) {
          target["activityId"] = value;
          target["activityPrice"] = target["activityList"].filter(
            (x) => x.id == value
          )[0].activityPrice;
          target["price"] = target["activityPrice"];
          target["activityDes"] = opt.label;
        } else {
          target["activityId"] = undefined;
          target["activityPrice"] = null;
          target["activityDes"] = null;
        }
        this.productList = newData;
      }
    },
    selectdealer() {
      this.dealerVisible = true;
    },
    async getDealerFreightOptions(id) {
      var result = await api.GetDealerDeafultFreight({ dealerId: id });
      if (result != null) {
        this.form.setFields({
          freightName: { value: result.name, errors: null },
        });
        this.form.setFields({
          freightTelephone: { value: result.telephone, errors: null },
        });
        this.freightDepartmentId = result.id;
      }
    },
    //选择用户
    async getSelectedDealer(p) {
      if (p) {
        if (this.dealerId != p.id) {
          this.form.resetFields();
          this.productList = [];
          this.cacheData = [];
          this.freightDepartmentId = null;
        }
        this.dealerId = p.id;
        this.getOrganizationOptions(this.dealerId);
        this.getDealerFreightOptions(this.dealerId);
        this.form.setFields({ dealerName: { value: p.name, errors: null } });
        // if (p.organizationId > 0) {
        //   this.form.setFields({
        //     organizationId: { value: p.organizationId + "", errors: null }
        //   });
        //   await this.orgChange(p.organizationId);
        // }
        // if (p.departmentId > 0) {
        //   this.form.setFields({
        //     departmentId: { value: p.departmentId + "", errors: null }
        //   });
        // }
        this.form.setFields({
          contact: { value: p.contact, errors: null },
        });
        this.form.setFields({
          telephone: { value: p.telephone, errors: null },
        });
        this.form.setFields({
          detailAddress: { value: p.address, errors: null },
        });
        this.defaultValue = [
          p.provinceId + "",
          p.cityId + "",
          p.districtId + "",
        ];
        // this.form.setFields({
        //   saleEmployeeName: { value: p.saleEmployeeName, errors: null }
        // });
      }
      this.GetDefaultAddress(this.dealerId);
      this.dealerVisible = false;
    },
    onEmployeeSearch() {
      let orgId = this.form.getFieldValue("organizationId");
      if (orgId > 0) {
        this.selectEmployeeParams = {
          organizationId: orgId,
          onlySale: true,
          departmentId: null,
        };
        this.selectEmployeeVisible = true;
      } else {
        this.$message.warn("请先选择销售组织");
        return;
      }
    },
    onAddressSearch() {
      if (this.dealerId <= 0) {
        this.$message.warn("请先选择经销商");
        return;
      }
      this.selectAddressParams = {
        dealerId: this.dealerId,
      };
      this.selectAddressVisible = true;
    },
    onFreightSearch() {
      if (this.dealerId <= 0) {
        this.$message.warn("请先选择经销商");
        return;
      }
      this.selectFreightParams = {
        dealerId: this.dealerId,
      };
      this.selectFreightVisible = true;
    },
    getSelectedEmployee(p) {
      this.selectEmployeeVisible = false;
      this.form.setFields({
        saleEmployeeName: { value: p.name, errors: null },
      });
      this.saleEmployeeId = p.id;
    },
    getSelectedDealerAddress(p) {
      this.form.setFields({
        contact: { value: p.contact, errors: null },
      });
      this.form.setFields({
        telephone: { value: p.telephone, errors: null },
      });
      this.form.setFields({
        detailAddress: { value: p.fullAddress, errors: null },
      });
      this.selectAddressVisible = false;
    },
    getSelectedDealerFreight(p) {
      this.form.setFields({
        freightName: { value: p.name, errors: null },
      });
      this.form.setFields({
        freightTelephone: { value: p.telephone, errors: null },
      });
      this.freightDepartmentId = p.id;
      this.selectFreightVisible = false;
    },
    async getAvailableBalanceByDealerId(dealerId, orgId) {
      this.availableBalance = 0;
      let result = await api.GetAvailableBalanceByDealerId({
        dealerId: dealerId,
        organizationId: orgId,
      });
      if (result) {
        this.availableBalance = Number(result).toFixed(2);
      }
    },
    async getPromotionActivityByProduct(dealerId, productId) {
      let result = await api.GetPromotionActivityForOrder({
        dealerId: dealerId,
        productId: productId,
        organizationId: this.form.getFieldValue("organizationId"),
      });
      return result;
    },
    async GetSalesPriceForOrder(dealerId, productId) {
      let result = await api.GetSalesPriceForOrder({
        dealerId: dealerId,
        productId: productId,
        organizationId: this.form.getFieldValue("organizationId"),
      });
      return result;
    },
    async GetSaleEmployee(dealerId, orgId) {
      let result = await api.GetDealerSaleEmployee({
        dealerId: dealerId,
        organizationId: orgId,
      });
      if (result) {
        this.form.setFields({
          saleEmployeeName: { value: result.name, errors: null },
        });
        this.saleEmployeeId = result.id;
      }
    },
    async GetDefaultAddress(dealerId) {
      let result = await api.GetDealerDefaultAddress({
        dealerId: dealerId,
      });
      if (result) {
        this.form.setFields({
          contact: { value: result.contact, errors: null },
        });
        this.form.setFields({
          telephone: { value: result.telephone, errors: null },
        });
        this.form.setFields({
          detailAddress: { value: result.fullAddress, errors: null },
        });
      }
    },
    //选择产品
    selectProduct() {
      if (this.dealerId <= 0) {
        this.$message.warn("请先选择经销商");
        return;
      }
      if (
        !(
          this.form.getFieldValue("organizationId") &&
          this.form.getFieldValue("organizationId") > 0
        )
      ) {
        this.$message.warn("请先选择销售组织");
        return;
      }
      this.selectProductParams = {
        isMultiple: true,
        organizationId: this.form.getFieldValue("organizationId"),
      };
      this.selectVisible = true;
    },
    async getProductInfo(product) {
      this.selectVisible = false;
      this.loading = true;
      product.forEach(async (element) => {
        await this.completeProduct(element).then((returnProductList) => {
          let childProductList = returnProductList.filter(
            (x) => x.parentProductId > 0
          );
          let p = returnProductList.filter((x) => x.parentProductId == 0)[0];

          if (childProductList.length > 0) {
            childProductList.forEach((x) => {
              p.price += x.price;
            });
            this.productList.push(p);

            childProductList.forEach((x) => {
              this.productList.push(x);
            });
          }
        });
      });

      this.loading = false;
    },

    async completeProduct(element) {
      let returnProductList = [];
      let newProduct = {
        productName: element.productName,
        productCode: element.productCode,
        specDes: element.specDes,
        isCustom: element.isCustom,
        isProcess: element.isProcess,
        isBom: element.isBom,
        quantity: 1,
        price: null,
        salesPrice: 0,
        expectedDeliveryDate:
          element.expectedDelivery > 0
            ? new moment()
                .add(element.expectedDelivery, "days")
                .startOf("day")
                .valueOf()
            : null,
        dealerExpectedDeliveryDate: null,
        activityId: undefined,
        activityPrice: null,
        activityDes: "",
        notes: "",
        productId: element.id,
        activityOptions: [],
        activityList: [],
        id: 0,
        parentProductId: 0,
      };
      newProduct.dealerExpectedDeliveryDate =
        newProduct.expectedDeliveryDate != null
          ? new moment(newProduct.expectedDeliveryDate)
          : null;
      if (
        this.productList.filter(
          (x) => x.productId == newProduct.productId && x.parentProductId == 0
        ).length > 0
      ) {
        this.$message.warn("存在相同的产品");
        return;
      } else {
        if (!newProduct.isBom) {
          let salesPrice = await this.GetSalesPriceForOrder(
            this.dealerId,
            newProduct.productId
          );
          if (salesPrice) {
            newProduct.salesPrice = salesPrice;
            newProduct.price = salesPrice;
          }
        }
        let activityList = await this.getPromotionActivityByProduct(
          this.dealerId,
          newProduct.productId
        );
        if (activityList && activityList.length > 0) {
          newProduct.activityList = activityList;
          activityList.forEach((a) => {
            newProduct.activityOptions.push({
              label: a.title,
              title: a.title,
              value: a.id,
            });
          });

          newProduct.activityId = newProduct.activityList[0].id;
          newProduct.activityPrice = newProduct.activityList.filter(
            (x) => x.id == newProduct.activityList[0].id
          )[0].activityPrice;
          newProduct.price = newProduct.activityPrice;
          newProduct.activityDes = newProduct.activityList[0].title;
        }
        var inventory = await api.GetInventory({
          organizationId: this.form.getFieldValue("organizationId"),
          productIdList: [newProduct.productId],
        });
        this.isInsufficientList = inventory.items;
        if (this.isInsufficientList != null) {
          newProduct.isInsufficient =
            inventory.items[0].quantity < newProduct.quantity;
        }

        returnProductList.push(newProduct);
        if (newProduct.isBom) {
          await api
            .GetProductPackageForOrder({
              dealerId: this.dealerId,
              productId: newProduct.productId,
              organizationId: this.form.getFieldValue("organizationId"),
            })
            .then((childProduct) => {
              if (childProduct) {
                childProduct.forEach((child) => {
                  let cp = {
                    productName: "【子件】" + child.productName,
                    productCode: child.productCode,
                    specDes: child.specDes,
                    isCustom: child.isCustom,
                    quantity: newProduct.quantity * child.quantity,
                    childQuantity: child.quantity,
                    price: child.price || null,
                    salesPrice: 0,
                    expectedDeliveryDate:
                      child.expectedDelivery > 0
                        ? new moment()
                            .add(element.expectedDelivery, "days")
                            .startOf("day")
                            .valueOf()
                        : null,
                    productId: child.id,
                    parentProductId: child.parentId,
                    isBom: false,
                  };
                  returnProductList.push(cp);
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
            });
        }
      }
      return returnProductList;
    },
    async getdetailOrder() {
      this.loading = true;
      let result = await api.GetOrderMaster({ orderMasterId: this.params.id });
      if (result) {
        this.data = result;
        this.defaultValue = [
          this.data.provinceId + "",
          this.data.cityId + "",
          this.data.districtId + "",
        ];
        this.dealerId = this.data.dealerId;
        this.saleEmployeeId = this.data.saleEmployeeId;
        this.freightDepartmentId = this.data.freightDepartmentId;
        this.isBreakBulk = this.data.deliveryMethod == 0;
        this.isHead = this.data.organizationId == this.headOrgId;
        await this.getOrganizationOptions(this.data.dealerId);
        await this.getDepartmentOptions(this.data.organizationId);
        await this.getAvailableBalanceByDealerId(
          this.dealerId,
          this.data.organizationId
        );
        this.data.organizationId = this.data.organizationId + "";
        if (this.data.departmentId > 0) {
          this.data.departmentId = this.data.departmentId + "";
        } else {
          this.data.departmentId = undefined;
        }
        this.data.deliveryMethod = this.data.deliveryMethod + "";
        let tempList = this.data.items.filter(
          (a) => a.parentProductId == null || a.parentProductId == 0
        );

        // this.productList = this.data.items;
        tempList.forEach((a) => {
          if (a.dealerExpectedDeliveryDate) {
            a.dealerExpectedDeliveryDate = new moment(
              a.dealerExpectedDeliveryDate
            );
            a.parentProductId = 0;
            this.productList.push(a);
            this.productIds.push(a.productId);
            let chList = this.data.items.filter(
              (y) => a.productId == y.parentProductId && y.parentProductId > 0
            );
            if (chList.length > 0) {
              chList.forEach((x) => {
                x.productName = "【子件】" + x.productName;
                x.childQuantity = x.quantity / a.quantity;
                if (x.dealerExpectedDeliveryDate) {
                  x.dealerExpectedDeliveryDate = new moment(
                    x.dealerExpectedDeliveryDate
                  );
                }
                this.productList.push(x);
              });
            }
          }
        });
      }
      var inventory = await api.GetInventory({
        organizationId: this.form.getFieldValue("organizationId"),
        productIdList: this.productIds,
      });
      this.isInsufficientList = inventory.items;
      if (this.isInsufficientList != null) {
        this.isInsufficientList.forEach((n) => {
          this.productList.forEach((a) => {
            if (n.productId == a.productId) {
              a.isInsufficient = n.quantity < a.quantity;
            }
          });
        });
      }

      this.loading = false;
    },
    // async getProductInventory(productId){
    //   console.log(productId);
    //   var inventory= await api.GetInventory({organizationId:this.form.getFieldValue("organizationId"),productIdList:[productId]});
    //   console.log(inventory);
    //   if(inventory.items[0]>=this.form.getFieldValue("quantity")){
    //     return false;
    //   }else{
    //     return true;
    //   }
    // },
    changeAddressdata(option) {
      this.data.provinceId = parseInt(option[0]);
      this.data.cityId = parseInt(option[1]);
      if (option[2]) {
        this.data.districtId = option[2];
      }
      this.form.setFieldsValue({
        provinceId: this.data.provinceId,
      });
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        dealerId: this.dealerId,
        contact: value.contact,
        organizationId: value.organizationId,
        saleEmployeeId: this.saleEmployeeId,
        departmentId: value.departmentId,

        telephone: value.telephone,
        backNotes: value.backNotes,
        provinceId: this.data.provinceId,
        cityId: this.data.cityId,
        districtId: this.data.districtId,
        detailAddress: value.detailAddress,
        deliveryMethod: value.deliveryMethod,
        items: [],
      };
      if (this.isBreakBulk) {
        result.freightDepartmentId = this.freightDepartmentId;
      }
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0],
          });
        });
      });
      if (!valid.err) {
        let data;
        let requestData = this.dataToPostData(valid.values);
        if (this.productList.length < 1) {
          this.$message.error("请选择产品");
          this.loading = false;
          return;
        }

        console.log(this.productList);
        this.productList.forEach((element) => {
          if (
            element.dealerExpectedDeliveryDate == null &&
            element.parentProductId == 0
          ) {
            this.$message.error("产品的要货日期未填写：" + element.productName);
            this.loading = false;
            return;
          }
          requestData.items.push({
            id: element.id || 0,
            productId: element.productId,
            productName: element.productName,
            productCode: element.productCode,
            specDes: element.specDes,
            quantity: element.quantity,
            price: element.price || 0,
            isProcess: element.isProcess,
            lotNumber: element.lotNumber,
            notes: element.notes,
            activityId: element.activityId,
            activityPrice: element.activityPrice,
            dealerExpectedDeliveryDate:
              element.dealerExpectedDeliveryDate != null
                ? element.dealerExpectedDeliveryDate.startOf("day").valueOf()
                : undefined,
            expectedDeliveryDate: element.expectedDeliveryDate,
            isBom: element.isBom,
            isCustom: element.isCustom,
            parentProductId: element.parentProductId,
          });
        });
        console.log(requestData);
        if (this.params.id > 0) {
          data = await api.UpdateOrderMaster(requestData);
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        } else {
          data = await api.CreateOrderMaster(requestData);
          if (data) {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
.editable-row-operations {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/router/Orders/OrderMaster/Add.vue